import { Home, Package, Briefcase, ShoppingBag, Mail, User, ExternalLink } from "lucide-react";
import { Newspaper } from "lucide-react";
import { useLocation, Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";
import { TouchInteractions } from "@/components/TouchInteractions";

const navigationItems = [
  {
    name: "Home",
    href: "/",
    icon: Home,
  },
  {
    name: "Fabbriche",
    href: "/fabbriche",
    icon: Package,
  },
  {
    name: "Progetti",
    href: "/progetti",
    icon: Briefcase,
  },
  {
    name: "Shop",
    href: "/shop",
    icon: ShoppingBag,
    external: false,
  },
  {
    name: "Notizie",
    href: "/notizie",
    icon: Newspaper,
  },
  {
    name: "Profilo",
    href: "/dashboard",
    icon: User,
    requiresAuth: true,
  },
];

export const BottomNavigation = () => {
  const location = useLocation();
  const { user } = useAuth();
  
  // Filter items based on auth status
  const visibleItems = navigationItems.filter(item => 
    !item.requiresAuth || (item.requiresAuth && user)
  );
  
  // Hide on dashboard pages
  if (location.pathname.startsWith('/dashboard')) return null;

  // Only show on mobile
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-background/95 backdrop-blur-sm border-t border-border">
      <div className={`grid h-16 ${visibleItems.length === 5 ? 'grid-cols-5' : visibleItems.length === 6 ? 'grid-cols-6' : 'grid-cols-5'}`}>
        {visibleItems.map((item) => {
          const isActive = location.pathname === item.href;
          const Icon = item.icon;
          
          const classes = cn(
            "flex flex-col items-center justify-center h-full transition-all duration-200 mobile-tap-highlight",
            "text-xs font-medium px-2",
            isActive 
              ? "text-primary" 
              : "text-foreground hover:text-primary"
          );

          if (item.external) {
            return (
              <TouchInteractions key={item.name} haptic={true}>
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes}
                >
                  <Icon className="w-5 h-5 mb-1" />
                  <span className="leading-tight flex items-center gap-0.5">{item.name}<ExternalLink className="w-2.5 h-2.5 opacity-50" /></span>
                </a>
              </TouchInteractions>
            );
          }
          
          return (
            <TouchInteractions key={item.name} haptic={true}>
              <Link
                to={item.href}
                className={classes}
              >
                <Icon className="w-5 h-5 mb-1" />
                <span className="leading-tight">{item.name}</span>
              </Link>
            </TouchInteractions>
          );
        })}
      </div>
      
      {/* Safe area for devices with home indicators */}
      <div className="h-safe-area-inset-bottom bg-background/95 backdrop-blur-sm" />
    </nav>
  );
};
